<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="onCancle">
    <div slot="modalBody">
      <follows-list ref="follow" :proprietorModel="model"></follows-list>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import followsList from '@/views/follows/list.vue'
export default {
  name: 'FlowModal',
  mounted () {

  },
  computed: {

  },
  components: {
    baseModal,
    followsList
  },
  data () {
    return {
      title: '操作',
      width: 1300,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'markets' }),
      visible: false,
      defaultModel: {},
      model: {},
      headers: {
        authorization: 'authorization-text'
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  methods: {
    // 关闭
    onCancle () {
      this.$emit('refreshTable')
      this.open(false)
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
    },
    cancel () {
      this.open(false)
    }
  }
}
</script>

<style scoped>

</style>
